import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import '../home.css';
import { LangSwitcher } from '../i18n';

const s = {
    root:   { minHeight: '100vh', background: '#050810', display: 'flex', flexDirection: 'column', fontFamily: '"Segoe UI", system-ui, sans-serif' },
    nav:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 48px', borderBottom: '1px solid rgba(29,78,216,0.15)' },
    logo:   { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' },
    logoI:  { width: 30, height: 30, borderRadius: '50%', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 },
    logoT:  { fontWeight: 800, fontSize: 18, color: '#f1f5f9' },
    center: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' },
    box:    { width: '100%', maxWidth: 380, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(29,78,216,0.2)', borderRadius: 20, padding: '40px 36px' },
    h1:     { fontSize: 26, fontWeight: 800, color: '#f1f5f9', marginBottom: 6, letterSpacing: '-0.5px' },
    sub:    { fontSize: 14, color: '#64748b', marginBottom: 32 },
    lbl:    { display: 'block', fontSize: 13, fontWeight: 600, color: '#94a3b8', marginBottom: 6, marginTop: 20 },
    inp:    { width: '100%', padding: '12px 14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, fontSize: 14, color: '#f1f5f9', outline: 'none', boxSizing: 'border-box' },
    err:    { marginTop: 16, padding: '12px 14px', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, color: '#fca5a5', fontSize: 13, textAlign: 'center' },
    btn:    { width: '100%', marginTop: 28, padding: '13px 0', border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: 'pointer' },
    reg:    { textAlign: 'center', marginTop: 24, fontSize: 14, color: '#64748b' },
    regL:   { color: '#60a5fa', cursor: 'pointer', fontWeight: 600 },
};

export default function Login() {
    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');
    const [error, setError]       = useState('');
    const [loading, setLoading]   = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await login(email, password);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('client', JSON.stringify(res.data.client));
            navigate('/dashboard', { replace: true });
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={s.root}>
            <nav style={s.nav}>
                <div style={s.logo} onClick={() => navigate('/')}>
                    <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 36, width: 'auto', borderRadius: 8, cursor: 'pointer' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <LangSwitcher />
                    <button onClick={() => navigate('/register')} className="og-btn-primary" style={{ padding: '9px 22px', fontSize: 14 }}>
                        Get Started
                    </button>
                </div>
            </nav>

            <div style={s.center}>
                <div style={s.box}>
                    <h1 style={s.h1}>Welcome back</h1>
                    <p style={s.sub}>Sign in to your OrbitGrowth account</p>

                    {error && <div style={s.err}>{error}</div>}

                    <form onSubmit={submit}>
                        <label style={s.lbl}>Email</label>
                        <input
                            style={s.inp}
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required autoFocus
                            placeholder="you@example.com"
                        />
                        <label style={s.lbl}>Password</label>
                        <input
                            style={s.inp}
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            placeholder="Your password"
                        />
                        <button
                            type="submit"
                            className="og-btn-primary"
                            style={{ ...s.btn, opacity: loading ? 0.7 : 1 }}
                            disabled={loading}
                        >
                            {loading ? 'Signing in...' : 'Sign In →'}
                        </button>
                    </form>

                    <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}>
                        <span style={s.regL} onClick={() => navigate('/forgot-password')}>Forgot password?</span>
                    </div>
                    <div style={s.reg}>
                        Don't have an account?{' '}
                        <span style={s.regL} onClick={() => navigate('/register')}>Create one &rarr;</span>
                    </div>
                    <p style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af', marginTop: 12 }}>
                        By logging in you agree to our{' '}
                        <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1', textDecoration: 'none' }}>Terms of Service</a>
                    </p>
                </div>

            </div>
        </div>
    );
}
